/* eslint-disable react/prop-types */
import { useEffect, useRef } from 'react';

function Checkout({ html, onError }) {
  const divRef = useRef();

  useEffect(() => {
    try {
      const fragment = document.createRange().createContextualFragment(html);
      divRef.current.append(fragment);
    } catch (err) {
      console.log(err);
      onError?.();
      return undefined;
    }

    const timer = setTimeout(() => {
      const form = document.querySelector('#checkoutform form');
      if (!form) {
        onError?.();
        return;
      }
      form.submit();
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="w-100 d-flex flex-column align-items-center justify-content-center mt-5">
      <div ref={divRef} id="checkoutform"></div>
    </div>
  );
}

export default Checkout;
